import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/used-product")({
  component: () => <Outlet />,
});
